import { render } from "./ConnectWalletModal.vue?vue&type=template&id=0c8b19cc"
import script from "./ConnectWalletModal.vue?vue&type=script&lang=js"
export * from "./ConnectWalletModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__